export default "__VITE_PUBLIC_ASSET__7f65f1f8__"